
<template>
  <vx-card class="grid-view-item mb-base overflow-hidden cursor-pointer" v-on="$listeners">
    <template slot="no-body">
      <div
        v-if="item.image"
        class="item-img-container bg-white h-64 flex items-center justify-center mb-4"
      >
        <img :src="item.image" :alt="item.name" class="grid-view-img" />
      </div>
      <div v-else class="mt-5"></div>
      <vs-prompt
        @cancel="itemDescriptionPrompt = false"
        @close="itemDescriptionPrompt = false"
        accept-text="確定"
        cancel-text="返回"
        @accept="itemDescriptionPrompt = false"
        title="食物詳情 Food Details"
        :active.sync="itemDescriptionPrompt"
        v-if="currentItemSelected"
      >
        <div class="vx-col w-full">
          <vx-card>
            <h6
              class="item-name font-semibold mb-1 hover:text-primary"
            >{{ currentItemSelected.name_chi }}</h6>
            <h6
              class="item-name font-semibold mb-1 hover:text-primary"
            >{{ currentItemSelected.name_english }}</h6>
            <h6
              class="item-name font-semibold mb-1 hover:text-primary"
            >{{ currentItemSelected.name_eng}}</h6>
            <p class="text-primary mb-4 mt-3">
              <span class="font-semibold cursor-pointer">${{ currentItemSelected.unit_price }} / 份(Unit)</span>
            </p>
            <p class="item-description text-sm">{{ currentItemSelected.description }}</p>
          </vx-card>
        </div>
      </vs-prompt>
      <div class="item-details px-4" @click="showMealDescription(item)">
        <div class="flex justify-between items-center">
          <div class="mb-5 py-1 px-1 w-full">
            <h5 class="truncate mb-1 hover:text-primary text-md">{{ item.name_chi }}</h5>

            <p
              class="truncate mb-1 hover:text-primary"
            >{{ item.name_english }}</p>
            <p
              class="truncate mb-1 hover:text-primary"
            >{{item.name_eng}}</p>
            <div class="flex justify-between items-center mt-2 mb-2">
              <div class="text-warning border border-solid border-warning flex px-2 rounded">
                <span class="text-sm">{{item.categories[0]}}</span>
              </div>
            </div>
            <h6 class="font-bold">${{ item.unit_price }} {{item.mealOption?'+':''}}</h6>
          </div>
        </div>
      </div>
      <slot name="action-buttons" />
    </template>
  </vx-card>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      itemDescriptionPrompt: false,
      currentItemSelected: {}
    };
  },
  methods: {
    navigate_to_detail_view() {
      this.$router
        .push({
          name: "ecommerce-item-detail-view",
          params: { item_id: this.item.objectID }
        })
        .catch(() => {});
    },
    showMealDescription(item) {
      this.itemDescriptionPrompt = true;
      this.currentItemSelected = item;
    }
  }
};
</script>

<style lang="scss" scoped>
.grid-view-item {
  .grid-view-img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    transition: 0.35s;
  }

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.25);

    .grid-view-img {
      opacity: 0.9;
    }
  }
}
</style>
